import { Author } from "@customTypes/Author";
import { SearchLandingType } from "@customTypes/SearchLandingType";
import { useSettings } from "@utilities/context/settings";
import clsx from "clsx";
import { useBSRContentPages } from "../../context/bsrContentPage";
import { AuthorItem } from "./AuthorItem";
import styles from "./C207_PopularAuthors.module.scss";

export interface PopularAuthorsProps {
  authorsHeading?: string;
  authorsList?: Author[];
}

export const PopularAuthors = (props: { content: PopularAuthorsProps }) => {
  const { content } = props;
  const { authorsHeading, authorsList } = content;

  const templateAuthorsHeading = useBSRContentPages().authorsHeading;
  const templateAuthorsList = useBSRContentPages().authorsList;
  const { siteSettings } = useSettings();

  const heading = authorsHeading || templateAuthorsHeading;
  const authorList = authorsList || templateAuthorsList;

  const thinkAuthorsPage =
    siteSettings?.searchResultsPagesCollection?.items?.filter(
      ({ type }) => type === SearchLandingType.ThinkAuthors
    )[0];

  return (
    <section className={clsx("component", styles["popular-authors"])}>
      <div className="wrapper">
        {heading && <h2>{heading}</h2>}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-15 gap-y-10">
          {authorList.map((author, idx) => {
            const {
              articleAuthorName,
              articleAuthorFacultyProfile,
              articleAuthorContributorProfile,
            } = author?.fields || {};

            const profileLink =
              articleAuthorFacultyProfile?.fields?.slug ||
              articleAuthorContributorProfile?.fields?.slug;
            const title =
              articleAuthorFacultyProfile?.fields?.profilePositionTitle ||
              articleAuthorContributorProfile?.fields?.profilePositionTitle;

            const authorName =
              articleAuthorFacultyProfile?.fields?.facultyProfileData?.fields
                ?.profileName || articleAuthorName;

            const imageUrl =
              articleAuthorFacultyProfile?.fields?.profilePhoto?.fields?.file
                ?.url ||
              articleAuthorContributorProfile?.fields?.profilePhoto?.fields
                ?.file?.url;

            const hasProfileLink = !!profileLink;
            const articlesLink = !hasProfileLink
              ? `/${thinkAuthorsPage?.url?.slug}?${thinkAuthorsPage?.queryParams}=${encodeURIComponent(
                  authorName.replaceAll(" ", "")
                )}`
              : undefined;

            return (
              <AuthorItem
                key={`${authorName}-${idx}`}
                authorName={authorName}
                title={title}
                imageUrl={imageUrl}
                profileLink={hasProfileLink ? `/${profileLink}` : undefined}
                articlesLink={articlesLink}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PopularAuthors;
